import { render, staticRenderFns } from "./fancyEditor.vue?vue&type=template&id=2c6233db"
import script from "./fancyEditor.vue?vue&type=script&lang=js"
export * from "./fancyEditor.vue?vue&type=script&lang=js"
import style0 from "./fancyEditor.vue?vue&type=style&index=0&id=2c6233db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports